import { MX_PCB_ASSEMBLY_ID, USA_PCB_ASSEMBLY_ID } from "product_tabs/tab_assembly/data/productVariants";

export default {
  "assembly-us": USA_PCB_ASSEMBLY_ID,
  "assembly-mx": MX_PCB_ASSEMBLY_ID,
}